import { isEmpty, keys } from 'lodash/fp';

import { ModalField, SetIsWidgetActive, ToggleModal } from '../../types';
import getPanelIndexForError from '../get-panel-index-for-error';

type OpenModalByErrorParams = {
  errors: Record<string, string>;
  modalFields: ModalField[];
  toggleModal: ToggleModal;
  setIsWidgetActive: SetIsWidgetActive;
};

const openModalByError = ({ modalFields, errors, toggleModal, setIsWidgetActive }: OpenModalByErrorParams) => {
  const errorFields = keys(errors);
  const firstErrorPanelIndex = getPanelIndexForError({ errors, modalFields });

  if (isEmpty(errorFields) || firstErrorPanelIndex === null) {
    return null;
  }

  toggleModal(firstErrorPanelIndex, true);
  setIsWidgetActive(true);
  return null;
};

export default openModalByError;
